// Central content + testids for Dr. Chanduka's site
export const NAV_LINKS = [
  { label: "Specializations", href: "#specializations" },
  { label: "Patient Education", href: "#symptoms" },
  { label: "About", href: "#about" },
  { label: "Community", href: "#community" },
  { label: "Blog", href: "#blog" },
  { label: "Gallery", href: "#gallery" },
];

export const SPECIALIZATIONS = [
  {
    name: "Endoscopic Discectomy",
    desc: "A keyhole technique to relieve a pinched nerve from a slipped disc, using a small camera and tiny incision so muscles are spared.",
    icon: "aperture",
  },
  {
    name: "TLIF",
    desc: "Transforaminal lumbar interbody fusion stabilises the lower spine when a segment has become worn or unstable, easing leg and back pain.",
    icon: "layers",
  },
  {
    name: "Open TLIF",
    desc: "The traditional, most established approach to TLIF, using a single incision for full direct visualization — best suited to complex or multi-level cases.",
    icon: "maximize",
  },
  {
    name: "MIS TLIF",
    desc: "The same TLIF fusion performed through a small tube that dilates the muscle instead of cutting it, generally allowing a faster, less painful recovery.",
    icon: "minimize",
  },
  {
    name: "Endo TLIF",
    desc: "The keyhole version of TLIF, performed through an incision typically under one centimetre with continuous camera visualization, for well-selected straightforward cases.",
    icon: "camera",
  },
  {
    name: "ACDF",
    desc: "Anterior cervical discectomy and fusion treats a compressed nerve or spinal cord in the neck, restoring comfortable movement.",
    icon: "columns",
  },
  {
    name: "Lateral Mass Fixation",
    desc: "A method of securing the cervical spine with carefully placed screws when the neck needs added stability and support.",
    icon: "grid",
  },
  {
    name: "Brain Tumor Surgery",
    desc: "Careful, planned removal of brain tumours using image guidance, with the goal of protecting healthy tissue and function.",
    icon: "brain",
  },
  {
    name: "General Neurosurgery",
    desc: "Assessment and treatment across the brain, spine and nerves — from trauma to degenerative conditions, guided by clear explanation.",
    icon: "activity",
  },
];

export const FAQS = [
  {
    q: "When does back pain need a spine specialist?",
    a: "Most back pain settles with time, movement and simple measures. It is worth seeing a specialist if the pain radiates down a leg or arm, comes with numbness, tingling or weakness, follows an injury, or lingers beyond about six weeks despite rest and physiotherapy. Any loss of bladder or bowel control needs urgent attention.",
  },
  {
    q: "Does a consultation mean I will need surgery?",
    a: "No. A consultation is an assessment, not a commitment. The large majority of spine problems are managed without an operation — through medication, physiotherapy, injections or simply time. Surgery is only discussed when it offers a clear advantage, and the decision always remains yours.",
  },
  {
    q: "What does recovery look like?",
    a: "It depends on the procedure. Minimally invasive techniques such as endoscopic discectomy often allow walking the same or next day and a return to light activity within one to two weeks. You will receive a written, procedure-specific plan covering movement, wound care and when to return to work.",
  },
  {
    q: "How is the cost of treatment estimated?",
    a: "Cost depends on the procedure, any implants, length of stay and your insurance or health scheme. After assessment you receive a written estimate before making any decision, with each charge explained plainly so there are no surprises.",
  },
];

export const CASE_NOTES = [
  {
    a: "A working parent in their forties arrived with months of leg pain from a slipped disc, worried an operation would mean weeks away from family. After discussion, a keyhole discectomy was chosen — walking resumed the next day, with a gradual return to routine.",
  },
  {
    a: "An older patient had been told nothing more could be done for neck pain and hand weakness. A careful reassessment identified a treatable compression; a planned procedure and structured physiotherapy restored day-to-day comfort.",
  },
  {
    a: "A young adult feared their symptoms pointed to something serious. Imaging and examination showed a condition that did not need surgery at all — reassurance, guided exercise and follow-up were enough to settle it.",
  },
];

export const BLOG = [
  {
    category: "Spine Health",
    title: "When Does Back Pain Need a Spine Surgeon?",
    teaser: "The warning signs worth taking seriously — and the many that simply need time and patience.",
  },
  {
    category: "Procedures",
    title: "Endoscopic Discectomy: Benefits, Recovery, What to Expect",
    teaser: "How the keyhole approach works, who it suits, and a realistic look at getting back on your feet.",
  },
  {
    category: "Recovery",
    title: "Life After Spine Surgery: A Week-by-Week Timeline",
    teaser: "A calm, honest walk through the first six weeks, from the first steps to returning to normal life.",
  },
];

export const SOCIALS = [
  { name: "Instagram", handle: "@dr.amitchanduka", icon: "instagram" },
  { name: "YouTube", handle: "Dr. Amit Chanduka", icon: "youtube" },
  { name: "Facebook", handle: "Dr. Amit Chanduka", icon: "facebook" },
  { name: "LinkedIn", handle: "Dr. Amit Chanduka", icon: "linkedin" },
];

export const GALLERY = [
  "Clinic exterior",
  "OPD interior",
  "Reception",
  "Conference / CME",
  "Equipment (non-patient)",
  "Village camp venue",
  "Credentials / certificates",
  "Team photo",
];

export const VIDEOS = [
  "Myth-busting: spine surgery recovery",
  "Procedure explainer: Endoscopic Discectomy",
  "Day in the OPD (non-clinical)",
];

export const REASONS = [
  "Back or neck pain",
  "Leg or arm pain / numbness",
  "Slipped disc (herniated disc)",
  "Sciatica",
  "Second opinion",
  "Brain-related concern",
  "Post-surgery follow-up",
  "Other",
];
